import { useQuery } from "react-query";
import {
    GetListTransactionShiftResponse,
    ParamsGetListTransactionShift,
} from "../../constants/types";
import axios from "../axios";

const queryString = require("query-string");

const handleRequest = async (params: ParamsGetListTransactionShift) => {
    const apiGetListTransactionShift = queryString.stringifyUrl({
        url: "/api/shift-transaksi",
        query: {
            ukmId: params.ukmId,
            shiftId: params.shiftId,
        },
    });
    const { data } = await axios.get<GetListTransactionShiftResponse>(apiGetListTransactionShift);
    return data.data;
};

export default function useListInvoice(params: ParamsGetListTransactionShift) {
    return useQuery<GetListTransactionShiftResponse["data"]>(
        ["list-trans-shift", params],
        () => handleRequest(params),
    );
}
